import React from 'react'

const ArrowRightIcon = () => {
	return (
		<svg width={26} height={24} viewBox='0 0 26 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M25.06 13.062a1.5 1.5 0 000-2.122l-9.545-9.546a1.5 1.5 0 10-2.122 2.122L21.88 12l-8.486 8.485a1.5 1.5 0 102.122 2.122l9.546-9.546zM0 13.5h24v-3H0v3z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default ArrowRightIcon
